import ClosedAnomaly from './pages/ClosedAnomaly';
import OpenAnomaly from './pages/OpenAnomaly';
import { TabsKey, ValidationMessage } from './types';

export const ANOMALY_TRACKER_TABS = [
  {
    key: TabsKey.OPEN_ANOMALY,
    value: 'Open',
    component: <OpenAnomaly />,
    relativePath: '/anomaly/open'
  },
  {
    key: TabsKey.CLOSED_ANOMALY,
    value: 'Closed',
    component: <ClosedAnomaly />,
    relativePath: '/anomaly/closed'
  }
];

export const DEFAULT_PAGINATION_STATE = {
  pageIndex: 0,
  pageSize: 10
};

export const COMMENT_VALIDATIONS = {
  minLength: { value: 20, message: 'Enter atleast 20 characters' },
  validate: {
    noOnlySpecialChars: (value: string) => {
      const trimmedValue = value.trim();
      if (trimmedValue === '' || /[a-zA-Z0-9]/.test(trimmedValue)) return true;
      return ValidationMessage.NO_ONLY_SPECIAL_CHARS;
    },
    noOnlyNumbers: (value: string) => {
      const trimmedValue = value.trim();
      if (trimmedValue === '' || !/^\d+$/.test(trimmedValue)) return true;
      return ValidationMessage.NO_ONLY_NUMBERS;
    },
    noNumbersAndSpecialChars: (value: string) => {
      const trimmedValue = value.replace(/[\s\n]/g, ''); // Remove spaces and newlines
      if (
        trimmedValue === '' ||
        !/^[0-9@#$%^&*!(){}[\]<>?/\\|`~.,:;"'+=-]*$/.test(trimmedValue) ||
        /[a-zA-Z]/.test(trimmedValue)
      )
        return true;
      return ValidationMessage.NO_NUMBERS_AND_SPECIAL_CHARS;
    }
  }
};
